import type { VariantModalConfig } from '../../../form/VariantModalForm/VariantModalForm';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type MediaConfigCropEventInit = {
  /**
   * Variants crop configuration with default presets that is array of objects with unique key,
   * label shown in the popover menu, name used when variant name is missing, and aspect ratio.
   */
  config: VariantModalConfig;
};

/**
 * An event that is fired when a variant modal with crop is open.
 * No result is expected, but the event may modify the config object for overriding crop presets.
 *
 * @eventName "flotiq.media.crop::config"
 * @memberof FlotiqPlugins.Events
 */
export class MediaConfigCropEvent extends IFlotiqPluginEvent {
  constructor(initData: MediaConfigCropEventInit) {
    super(initData);
  }
}
